import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DocumentLinksService } from '@personal-area/global/document-links';

@Component({
  selector: 'global-footer-terms-links',
  templateUrl: './footer-terms-links.component.html',
  styleUrls: ['./footer-terms-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class FooterTermsLinksComponent {
  documentLinksService = inject(DocumentLinksService);
}
